import React from "react";

export default function RewriteItPage() {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">✍️ RewriteItAI</h1>
      <p className="mb-6 text-lg">
        Your personal AI assistant for rewriting with clarity, confidence, and
        tone.
      </p>

      <p className="mb-4">
        Say goodbye to awkward drafts. <strong>RewriteItAI</strong> helps you
        instantly polish or rephrase your writing for tone, clarity, and impact.
      </p>

      <ul className="list-disc list-inside mb-6">
        <li>📧 Rewrite professional emails</li>
        <li>🐦 Refresh social media posts</li>
        <li>📝 Improve essays, cover letters, and long-form writing</li>
        <li>🎯 Tailor tone — polite, professional, friendly, or concise</li>
      </ul>

      <p className="mb-4">
        Paste your text, select your tone, and let Rewrite It AI handle the
        rest.
      </p>
      <p className="mb-6 font-semibold">Write once. Say it better.</p>

      <a
        href="https://apps.apple.com/us/app/rewriteitai/id6746104594"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-blue-600 text-white px-6 py-3 rounded-xl shadow hover:bg-blue-700 transition"
      >
        Try it Now on the App Store
      </a>
    </div>
  );
}
